var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container p-0"},[_c('b-tabs',{staticClass:"my-2",attrs:{"justified":"","lazy":""}},[_c('b-tab',{attrs:{"index":"provider_products","title":"Catálogo"}},[_c('clinic-provider-products')],1),_vm._v(" "),_c('b-tab',{attrs:{"index":"provider_families","title":"Familias"}},[_c('clinic-provider-families')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }